import React, { Suspense, useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { ExternalFormatPrice, ExternalSearchParamsContextProps, Overlay } from '@ibe/components';
import { ConfigModel } from '@ibe/services';
import { useMount } from 'react-use';

import theme from '../Theme/theme';
import '../Theme/Styles/widgets.scss';

import initI18next from '../Translations/setup';
import { bootMinimal } from '../Config/minimalConfig';
import { ThgConfigModel } from '../Config/ThgConfigModel';
import { extendedConfigContext } from '../Config/extendedConfigContext';

import Wishlist from '../Components/Wishlist';
import formatTHGPrice from '../Util/formatTHGPrice';

export interface WishlistWidgetProps {
  thgConfig: ThgConfigModel;
  configOverrides?: ConfigModel;
  mode: ExternalSearchParamsContextProps['mode'];
}

const WishlistWidget = ({
  thgConfig,
  configOverrides,
  mode
}: WishlistWidgetProps): React.ReactElement => {
  const [bootstrappingFinished, setBootstrappingFinished] = useState<boolean>(false);

  useMount(async () => {
    await initI18next(
      thgConfig.baseUrl,
      thgConfig.version,
      configOverrides?.tenant ?? undefined,
      mode
    );

    await bootMinimal(configOverrides, thgConfig);

    setBootstrappingFinished(true);
  });

  if (!bootstrappingFinished) {
    return (
      <div id="iso" className="iso__transparent" style={{ minHeight: '120px' }}>
        <Overlay />
      </div>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <div id="iso" className="iso__transparent wishlist-widget">
        <Suspense fallback={<Overlay fullOpacity />}>
          <extendedConfigContext.Provider value={thgConfig}>
            <ExternalFormatPrice externalFormatPrice={formatTHGPrice}>
              <Wishlist />
            </ExternalFormatPrice>
          </extendedConfigContext.Provider>
        </Suspense>
      </div>
    </ThemeProvider>
  );
};

export default WishlistWidget;
